import equal from 'fast-deep-equal';

const getSitePropertiesToUpdate = (initialProperties, currentProperties) => {
  const propertiesToUpdate = [];

  Object.keys(currentProperties).forEach((property) => {
    if (
      !initialProperties ||
      initialProperties[property] === undefined ||
      equal(currentProperties[property], initialProperties[property])
    )
      return;

    propertiesToUpdate.push({
      name: property,
      value: currentProperties[property],
    });
  });

  return propertiesToUpdate;
};

export default getSitePropertiesToUpdate;
